import React from "react";
export default function NewsIcon(props) {
  return (
    <svg
      width="49px"
      height="53px"
      viewBox="0 0 49 53"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Light-and-frame-position-"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="Instructions"
          transform="translate(-332.000000, -363.000000)"
          stroke="#FFFFFF"
          strokeWidth="3.2571"
        >
          <g id="Group-5" transform="translate(334.000000, 365.000000)">
            <rect
              id="Rectangle"
              x="0"
              y="0"
              width="35.3571429"
              height="40.2888889"
              rx="0.814275"
            ></rect>
            <path
              d="M45,11.9777778 L45,47.3666667 C44.988459,48.2638285 44.275633,48.9882709 43.3928571,49 L12.8571429,49"
              id="Path"
            ></path>
            <line
              x1="35.3571429"
              y1="31.5777778"
              x2="0"
              y2="31.5777778"
              id="Path"
            ></line>
            <path
              d="M7.5,31.5777778 L18.6428571,15.3968889 C19.2082494,14.5720193 20.1158554,14.0576519 21.1035156,14.0023602 C22.0911758,13.9470686 23.0488807,14.3570114 23.7,15.1137778 L35.3571429,28.8555556"
              id="Path"
            ></path>
            <path
              d="M9.64285714,6.53333333 C11.4180581,6.53333333 12.8571429,7.99586982 12.8571429,9.8 C12.8571429,11.6041302 11.4180581,13.0666667 9.64285714,13.0666667 C7.86765616,13.0666667 6.42857143,11.6041302 6.42857143,9.8 C6.42857143,7.99586982 7.86765616,6.53333333 9.64285714,6.53333333"
              id="Path"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}
